import apiClient from './apiClient';

export interface ReverseCandidate {
  fj170_01: string; // 領用單號
  fj170_11: string; // 領用日期
  fj170_13: string; // 說明
  fj170_80: string; // 狀態碼
  fj170_90: number; // 沖銷版次
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

export const pwj5m7Api = {
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwj5m7/candidates', { params });
    return res.data;
  },

  async reverse(items: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/pwj5m7/reverse', { items });
    return res.data;
  },
};
